import request from '@/libs/request';
import config from '@/config';
const baseUrl = config.api_base;

// 站点数量统计
// export const SiteStat = params => {
export const SiteStat = params => {
  return request('get', `${baseUrl}/api/auth/home/station/stat`, params);
};

// 最近站点事件
// export const SiteEvent = params => {
export const SiteEvent = params => {
  return request('get', `${baseUrl}/api/auth/home/station/event`, params);
};

// 最近设备事件
export const DeviceEvent = params => {
  return request('get', `${baseUrl}/api/auth/home/device/event`, params);
};

// 设备总览-设备数量统计
export const DeviceStat = params => {
  return request('get', `${baseUrl}/api/auth/home/device/stat`, params);
};

// 设备模型统计
export const ModelStat = params => {
  return request('get', `${baseUrl}/api/auth/home/device/model/stat`, params);
};

// 告警统计
export const AlarmStat = params => {
  return request('get', `${baseUrl}/api/auth/home/device/alarm/stat`, params);
};

// 设备故障排行
/**
 * @param
method: GET;
request body:
{
    type:"故障类型，int类型, 0-离线，1-告警，2-故障。不填时则默认值为0",
    startTime:"开始时间，必填, 长整型long",
    endTime:"结束时间，必填, 长整型long"
}
response body: 
data:[{
    devId:"设备主键",
    name:"设备名称",
    icon:"设备icon",
    devSn:"设备SN",
    faultDynamicStatus:"故障类型,int类型，0-离线，1-告警，2-故障",
    totalDurationFrequency:"设备故障总次数, 整型int",
    totalDurationTime:"设备故障总时长，单位秒, 长整型long"
}]} params 
 * @returns 
 */
export const DeviceFaultRank = params => {
  return request('get', `${baseUrl}/api/auth/home/fault/stat/device/rate`, params);
};

// 设备故障统计
export const DeviceFaultStat = params => {
  return request('get', `${baseUrl}/api/auth/home/fault/stat/device/history`, params);
};
